// extracted by mini-css-extract-plugin
module.exports = {"radioInputRow":"v_r1","radioInputColumn":"v_r2","inputOptionRow":"v_rN","inputOptionColumn":"v_rP"};